import { useState } from 'react';

import { Space, Select, Input } from 'antd';

const { Search } = Input;

function FilterSearch({ id, options, onFilterApply }) {
  const [searchInput, setSearchInput] = useState('');
  const [selectedValue, setSelectedValue] = useState(options?.[0].value);
  const onSearch = (value) => {
    if (!value || value.trim() === '') return;
    onFilterApply('input', selectedValue, value);
    setSearchInput('');
  };
  return (
    <Space className="g-0">
      <Select
        options={options}
        value={selectedValue}
        onChange={(value) => {
          setSelectedValue(value);
        }}
        defaultValue={options?.[0].value}
        className="group__select"
      />
      <Search
        id={id}
        value={searchInput}
        onChange={(e) => setSearchInput(e.target.value)}
        className="input__radius__left__0"
        placeholder="Search"
        onSearch={onSearch}
      />
    </Space>
  );
}

export default FilterSearch;
